import React from 'react';
import { Descriptions, Button } from 'antd';
import * as numeral from 'numeral';

import { moneyFormat, transaction } from '../../common/constants';

const TransactionDetail = ({ translate, detail, onCancel, onConfirm }) => {
  return(
    <div className="transaction-modal">
      <Descriptions column={1}>
        <Descriptions.Item label={translate('transaction.transactionType')}>{transaction[detail.transactionType]}</Descriptions.Item>
        <Descriptions.Item label={translate('transaction.transactionAmount')}>{numeral(detail.amount).format(moneyFormat)}</Descriptions.Item>
      </Descriptions>
      <div className="action-footer">
        <Button type="primary" onClick={() => onConfirm(detail)}>
          {translate('transaction.confirm')}
        </Button>
        <Button type="danger" onClick={onCancel}>
          {translate('transaction.cancel')}
        </Button>
      </div>
    </div>
  )
}

export default TransactionDetail;
